import { render, staticRenderFns } from "./AverageDelayDashboard.vue?vue&type=template&id=4795d623&scoped=true"
import script from "./AverageDelayDashboard.vue?vue&type=script&lang=js"
export * from "./AverageDelayDashboard.vue?vue&type=script&lang=js"
import style1 from "./AverageDelayDashboard.vue?vue&type=style&index=1&id=4795d623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4795d623",
  null
  
)

export default component.exports